/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';
import type { Theme, TypographyProps } from '@coursera/cds-core';

const MAX_COMMENT_LINES = 5;

type ReviewCommentProps = {
  comment: string;
  textVariant: TypographyProps['variant'];
  css?: (theme: Theme) => SerializedStyles | string;
};

const styles = {
  comment: css`
    margin: 0;
  `,
};

export const ReviewComment = ({ comment, textVariant, css: customCSS }: ReviewCommentProps) => {
  // Handles newline characters

  if (!comment) {
    return null;
  }

  const commentLines = comment?.split(/\\n/);
  const commentExceedsMaxLines = commentLines?.length > MAX_COMMENT_LINES;

  return (
    <>
      {commentLines.map((text) => (
        <React.Fragment key={text}>
          {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
          <Typography
            display={commentExceedsMaxLines ? 'inline' : 'block'}
            variant={textVariant}
            css={customCSS || styles.comment}
          >
            {text}
          </Typography>
        </React.Fragment>
      ))}
    </>
  );
};
